import React from "react";
import { ReactComponent as MicrosoftIcon } from "./../../media/icon_microsoft.svg";

export default function MicrosoftSVG() {
  return (
    <>
      <span className="anticon">
        <MicrosoftIcon />
      </span>
    </>
  );
}
